import React, { useEffect, useState } from "react";
import TableCard from "../../components/TableCard";
import { Paid } from "@mui/icons-material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import CheckIcon from "@mui/icons-material/Check";
import { keyframes } from "@emotion/react";
import {
  atualizarCondicaoComercial,
  atualizarValoresFatura,
  buscarValoresFatura,
  buscarValoresFaturasPorCampo,
  cadastrarCondicaoComercial,
  cadastrarValorFatura,
  excluirCondicaoComercial,
  excluirValoresFatura,
} from "../../services/api-financeiro.service";
import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  Grid,
  TextField,
} from "@mui/material";
import styles from "./styles.module.css";
import GenericDatePicker from "../../components/GenericDatePicker";
import { buscarComboPorCodigo } from "../../services/auth.service";
import BlueButton from "../../components/BlueButton";
import WhiteButton from "../../components/WhiteButton";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import Loading from "../../components/Loading";
import InputAdornment from "@mui/material/InputAdornment";

const ValoresFatura = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPage, setRowsPage] = useState(5);
  const [openModalInsert, setOpenModalInsert] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [listaServicos, setListaServicos] = useState([
    { value: "", label: "" },
  ]);
  const [idFinanceiroValorFatura, setIdFinanceiroValorFatura] = useState(null);
  const [idGrupoEconomico, setIdGrupoEconomico] = useState(null);
  const [idEmpresa, setIdEmpresa] = useState(null);
  const [dataFatura, setDataFatura] = useState({ content: null, error: false });
  const [valorFatura, setValorFatura] = useState({
    content: "0",
    error: false,
  });
  const [historico, setHistorico] = useState({ content: null, error: false });
  const [servico, setServico] = useState({ content: null, error: false });

  const [openSnackSucesso, setOpenSnackSucesso] = useState(false);
  const [openSnackErro, setOpenSnackErro] = useState(false);
  const [msg, setMsg] = useState(null);

  const handleCloseSnackSucesso = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackSucesso(false);
  };
  const handleCloseSnackErro = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackErro(false);
  };

  const columns = ["Serviço", "Data", "Valor", "Histórico"];

  const handleAtualizaDados = async () => {
    try {
      setLoading(true);

      const response = await buscarValoresFatura(idEmpresa);
      const responseOrganizada = handleOrganizaData(response.valoresFatura);
      setData(responseOrganizada);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setMsg(error.response.data.mensagem);
      setOpenSnackErro(true);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await buscarValoresFatura(idEmpresa);

        const responseOrganizada = handleOrganizaData(response.valoresFatura);
        setData(responseOrganizada);
      } catch (error) {
        setData([]);
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    idEmpresa ? fetchData() : setData([]);
  }, [idEmpresa]);

  useEffect(() => {
    // if (textoBusca) {
    //   handlePesquisaPorTexto(textoBusca);
    // } else {
    idEmpresa && handleAtualizaDados();
    // }
  }, [rowsPage, page]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const listaServicosApi = await handleRenderListAutoComplete("SERVICO");
        const novaListaServicos = listaServicosApi.map((item) => ({
          value: item.id,
          label: item.detalhes,
        }));

        setListaServicos(novaListaServicos);
      } catch (error) {
        console.log(error);
      }
    };
    if (openModalInsert && !isEdit) fetch();
  }, [openModalInsert]);

  const handleRenderListAutoComplete = async (codCombo) => {
    const response = await buscarComboPorCodigo(codCombo);
    const combosFormat = response.detalhes.itensCombo
      .filter((item) => item)
      .map((item) => {
        const split = item.split("/|/");
        return {
          id: split[0],
          detalhes: split[1],
        };
      });

    return combosFormat;
  };

  const handleOpenModalInsert = async () => {
    setOpenModalInsert(true);
  };

  const handleOpenModalDelete = async () => {
    setOpenModalDelete(true);
  };

  const handleCloseModalInsert = () => {
    setOpenModalInsert(false);
    setListaServicos([]);
    setIdFinanceiroValorFatura(null);
    setDataFatura({ content: null, error: false });
    setValorFatura({
      content: "0",
      error: false,
    });
    setHistorico({ content: null, error: false });
    setServico({ content: null, error: false });
  };

  const handleCloseModalDelete = () => {
    setOpenModalDelete(false);
  };

  const handleOrganizaData = (dados) => {
    return dados.map((item) => {
      return {
        servico: item.ServicosORM.descricao,
        data: new Date(
          new Date(item.dtFatura).getTime() + 3 * 60 * 60 * 1000
        ).toLocaleDateString("pt-BR"),
        valor:
          "R$ " +
          parseFloat(item.valorFatura).toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
          }),
        historico: item.historico,
        botoes: [
          {
            icon: <EditIcon />,
            title: "EDITAR",
            onClick: async () => {
              try {
                setIsEdit(true);
                const listaServicosApi = await handleRenderListAutoComplete(
                  "SERVICO"
                );
                const novaListaServicos = listaServicosApi.map((item) => ({
                  value: item.id,
                  label: item.detalhes,
                }));

                setListaServicos(novaListaServicos);
                setIdFinanceiroValorFatura(item.idFinanceiroValorFatura);
                setDataFatura(item.dtFatura);
                setValorFatura({ content: item.valorFatura, error: false });
                setHistorico({ content: item.historico, error: false });
                const servicoEncontrado = novaListaServicos.find(
                  (servico) => servico.label === item.ServicosORM.descricao
                );
                const resultado = servicoEncontrado
                  ? {
                      value: servicoEncontrado.value,
                      label: servicoEncontrado.label,
                    }
                  : null;
                setServico({ content: resultado, error: false });
                handleOpenModalInsert();
              } catch (error) {
                console.log(error);
              }
            },
          },
          {
            icon: <DeleteForeverIcon />,
            title: "EXCLUIR",
            onClick: () => {
              setIdFinanceiroValorFatura(item.idFinanceiroValorFatura);
              handleOpenModalDelete();
            },
          },
        ],
      };
    });
  };

  let debounceTimeout;

  const handlePesquisaPorTexto = async (value) => {
    if (value === "") {
      handleAtualizaDados();
    } else {
      clearTimeout(debounceTimeout);
      // debounceTimeout = setTimeout(async () => {
      try {
        setLoading(true);
        const response = await buscarValoresFaturasPorCampo(
          idGrupoEconomico,
          value
        );
        setData(handleOrganizaData(response.valoresFatura));
      } catch (error) {
        if (error.response.status == 404) {
          setData([]);
        } else {
          setMsg(error.response.data.mensagem);
          setOpenSnackErro(true);
        }
      } finally {
        setLoading(false);
      }
      // }, 500);
    }
  };

  const handleSubmitInsert = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!servico.content) servico.error = true;
    if (!dataFatura.content) dataFatura.error = true;

    if (dataFatura.error || servico.error) {
      setMsg("Preencha todos os campos obrigatórios.");
      setOpenSnackErro(true);
      setLoading(false);
      return;
    }

    const dataFaturaFormatada = new Date(dataFatura.content)
      .toISOString()
      .slice(0, 10);

    const objInsert = {
      valoresFatura: {
        dtFatura: dataFaturaFormatada,
        idServico: parseInt(servico.content.value),
        valorFatura: valorFatura.content || "0",
        historico: historico.content,
      },
    };

    try {
      const response = await cadastrarValorFatura(idEmpresa, objInsert);
      setLoading(false);
      setMsg(response.mensagem);
      setOpenSnackSucesso(true);
      handleCloseModalInsert();
      handleAtualizaDados();
    } catch (error) {
      setLoading(false);
      setMsg(error.response.data.mensagem);
      setOpenSnackErro(true);
    }
  };

  const handleSubmitUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!servico.content) servico.error = true;
    if (!dataFatura.content && typeof dataFatura != "string")
      dataFatura.error = true;

    if (dataFatura.error || servico.error) {
      setMsg("Preencha todos os campos obrigatórios.");
      setOpenSnackErro(true);
      setLoading(false);
      return;
    }

    const objUpdate = {
      valoresFatura: {
        dtFatura: dataFatura.content,
        idServico: parseInt(servico.content.value),
        valorFatura: valorFatura.content || "0",
        historico: historico.content,
      },
    };

    try {
      const response = await atualizarValoresFatura(
        idEmpresa,
        idFinanceiroValorFatura,
        objUpdate
      );
      setLoading(false);
      setMsg(response.mensagem);
      setOpenSnackSucesso(true);
      handleCloseModalInsert();
      handleAtualizaDados();
    } catch (error) {
      setLoading(false);
      setMsg(error.response.data.mensagem);
      setOpenSnackErro(true);
    }
  };

  const handleSubmitDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await excluirValoresFatura(
        idEmpresa,
        idFinanceiroValorFatura
      );
      setLoading(false);
      setMsg(response.mensagem);
      setOpenSnackSucesso(true);
      handleCloseModalDelete();
      handleAtualizaDados();
    } catch (error) {
      setLoading(false);
      setMsg(error.response.data.mensagem);
      setOpenSnackErro(true);
    }
  };

  const pulse = keyframes`
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }`;

  const handleChangeValue = (name, value) => {
    switch (name) {
      case "servico":
        setServico({ content: value, error: value != null ? false : true });
        break;
      case "dataFatura":
        if (!isNaN(value.getTime())) {
          setDataFatura({
            content: value,
            error: value != null ? false : true,
          });
        } else {
          setDataFatura({
            content: value,
            error: true,
          });
        }
        break;
      case "valorFatura":
        setValorFatura({ content: value, error: value != null ? false : true });
        break;
      case "historico":
        setHistorico({ content: value, error: value != null ? false : true });
        break;
      default:
        break;
    }
  };

  const handleBuscaEmpresas = (obj) => {
    setIdGrupoEconomico(parseInt(obj.GE?.id));
    setIdEmpresa(parseInt(obj.CNPJ?.id));
  };

  return (
    <>
      <TableCard
        iconHeader={<Paid fontSize="1rem" />}
        titleHeader="Valores de Fatura"
        data={data}
        setData={setData}
        columns={columns}
        loading={loading}
        handleDebounce={handlePesquisaPorTexto}
        page={page}
        setPage={setPage}
        rowsPage={rowsPage}
        setRowsPage={setRowsPage}
        handleGrupoEmpresa={handleBuscaEmpresas}
        hasEmpresa
        uniqueEmpresa
      />
      {idEmpresa ? (
        <Fab
          sx={{
            background: "#4b6fc0",
            bottom: 40,
            right: 20,
            position: "fixed",
            zIndex: 1000,
            animation: `${pulse} 1.5s infinite ease-in-out`,
            "&:hover": {
              backgroundColor: "#fff",
            },
          }}
          aria-label="add"
          onClick={() => {
            setIsEdit(false);
            handleOpenModalInsert();
          }}
        >
          <AddIcon className={styles.iconeAdd} />
        </Fab>
      ): ""}
      <Dialog fullWidth open={openModalInsert} onClose={handleCloseModalInsert}>
        <DialogTitle>
          <h4>{isEdit ? "Atualizar" : "Inserir"} valor de fatura</h4>
        </DialogTitle>
        <DialogContent>
          <form onSubmit={isEdit ? handleSubmitUpdate : handleSubmitInsert}>
            <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  sx={{ marginTop: "1rem" }}
                  size="small"
                  options={listaServicos}
                  value={servico.content}
                  onChange={(_, value) => handleChangeValue("servico", value)}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  fullWidth
                  renderInput={(params) => (
                    <TextField
                      error={servico.error}
                      {...params}
                      label="Serviço"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <GenericDatePicker
                  key={"dataFatura"}
                  label={`Dt. Fatura`}
                  value={dataFatura}
                  name="inputDataFatura"
                  error={dataFatura.error}
                  onChange={(value) => handleChangeValue("dataFatura", value)}
                  sx={{ marginTop: "1rem" }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  error={valorFatura.error}
                  value={valorFatura.content}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">R$</InputAdornment>
                    ),
                  }}
                  onChange={(event) =>
                    handleChangeValue("valorFatura", event.target.value)
                  }
                  fullWidth
                  size="small"
                  label="Valor da Fatura"
                  sx={{ marginTop: "1rem" }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  error={historico.error}
                  value={historico.content}
                  onChange={(event) =>
                    handleChangeValue("historico", event.target.value)
                  }
                  fullWidth
                  size="small"
                  label="Histórico"
                  sx={{ marginTop: "1rem" }}
                />
              </Grid>
            </Grid>
            <DialogActions
              sx={{
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <WhiteButton
                clickFunction={handleCloseModalInsert}
                textValue="Fechar"
                contentIcon={<CloseIcon />}
                iconLeft
              />

              <BlueButton
                textValue="Salvar"
                type="submit"
                contentIcon={<SendIcon />}
              />
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog open={openModalDelete} onClose={handleCloseModalDelete}>
        <DialogContent>
          <h2 style={{ fontSize: "1.1rem" }}>
            Deseja mesmo excluir esse valor de fatura?
          </h2>
          <div className={styles.containerButtons}>
            <WhiteButton
              textValue="Não"
              contentIcon={<CloseIcon />}
              clickFunction={handleCloseModalDelete}
              iconLeft
            />
            <BlueButton
              textValue="Sim"
              contentIcon={<CheckIcon />}
              clickFunction={handleSubmitDelete}
            />
          </div>
        </DialogContent>
      </Dialog>

      <MensagemSucesso
        open={openSnackSucesso}
        msg={msg}
        handleClose={handleCloseSnackSucesso}
      />
      <MensagemErro
        open={openSnackErro}
        msg={msg}
        handleClose={handleCloseSnackErro}
      />
    </>
  );
};

export default ValoresFatura;
